import * as React from "react";
import PropTypes from "prop-types";
import parseIconsFromServer from "nexia_mobile/parseIconsFromServer";

const IconFromServer = ({ value }) => (
  <span>
    {parseIconsFromServer(value).map((icon) =>
      React.cloneElement(icon.element, { key: icon.key })
    )}
  </span>
);
IconFromServer.propTypes = {
  // The number of Icon formats the server can return is unholy.
  // They all get handled by parseIconsFromServer, though,
  // so don't worry about it here in the prop types.
  /* eslint-disable react/forbid-prop-types */
  value: PropTypes.any.isRequired,
};

export default IconFromServer;



// WEBPACK FOOTER //
// ./src/components/IconFromServer.jsx